import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgAiNotDetectIcon, LazySvgBedIcon, LazySvgFloorIcon, LazySvgGlobalAiIcon, LazySvgGlobalChevronLeft, LazySvgGlobalCookie, LazySvgGlobalGoogle, LazySvgHomePageLine, LazySvgLampIcon, LazySvgObjectsArtIcon, LazySvgObjectsBacksplashIcon, LazySvgObjectsCeilingIcon, LazySvgObjectsChairIcon, LazySvgObjectsCouchIcon, LazySvgObjectsCurtainsIcon, LazySvgObjectsFloorIcon, LazySvgObjectsLampIcon, LazySvgObjectsMirrorIcon, LazySvgObjectsOtherIcon, LazySvgObjectsRefrigeratorIcon, LazySvgObjectsRugIcon, LazySvgObjectsTableIcon, LazySvgObjectsToiletIcon, LazySvgObjectsWallIcon, LazySvgPlanetIcon, LazySvgSofaIcon, LazySvgTvIcon, LazyIcon, LazyIconCSS } from '#components'
const lazyGlobalComponents = [
  ["SvgAiNotDetectIcon", LazySvgAiNotDetectIcon],
["SvgBedIcon", LazySvgBedIcon],
["SvgFloorIcon", LazySvgFloorIcon],
["SvgGlobalAiIcon", LazySvgGlobalAiIcon],
["SvgGlobalChevronLeft", LazySvgGlobalChevronLeft],
["SvgGlobalCookie", LazySvgGlobalCookie],
["SvgGlobalGoogle", LazySvgGlobalGoogle],
["SvgHomePageLine", LazySvgHomePageLine],
["SvgLampIcon", LazySvgLampIcon],
["SvgObjectsArtIcon", LazySvgObjectsArtIcon],
["SvgObjectsBacksplashIcon", LazySvgObjectsBacksplashIcon],
["SvgObjectsCeilingIcon", LazySvgObjectsCeilingIcon],
["SvgObjectsChairIcon", LazySvgObjectsChairIcon],
["SvgObjectsCouchIcon", LazySvgObjectsCouchIcon],
["SvgObjectsCurtainsIcon", LazySvgObjectsCurtainsIcon],
["SvgObjectsFloorIcon", LazySvgObjectsFloorIcon],
["SvgObjectsLampIcon", LazySvgObjectsLampIcon],
["SvgObjectsMirrorIcon", LazySvgObjectsMirrorIcon],
["SvgObjectsOtherIcon", LazySvgObjectsOtherIcon],
["SvgObjectsRefrigeratorIcon", LazySvgObjectsRefrigeratorIcon],
["SvgObjectsRugIcon", LazySvgObjectsRugIcon],
["SvgObjectsTableIcon", LazySvgObjectsTableIcon],
["SvgObjectsToiletIcon", LazySvgObjectsToiletIcon],
["SvgObjectsWallIcon", LazySvgObjectsWallIcon],
["SvgPlanetIcon", LazySvgPlanetIcon],
["SvgSofaIcon", LazySvgSofaIcon],
["SvgTvIcon", LazySvgTvIcon],
["Icon", LazyIcon],
["IconCSS", LazyIconCSS],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
